import apiClient from "./apiClient";

const twoFactorApi = {
  status: () => apiClient.get("/auth/2fa/status").then(r => r.data),
  setup: () => apiClient.post("/auth/2fa/setup").then(r => r.data),
  activate: (code1, code2) => apiClient.post("/auth/2fa/activate", { code1, code2 }).then(r => r.data),
  disable: (code) => apiClient.post("/auth/2fa/disable", { code }).then(r => r.data),
  login: (preAuthToken, code) => apiClient.post("/auth/2fa/login", { preAuthToken, code }).then(r => r.data),
};

export default twoFactorApi;
